module.exports = __webpack_public_path__ + "kudos_53.svg?f041568eddcfb9d90edbf5ca530193bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_53.svg
// module id = 154
// module chunks = 0